import { Injectable } from '@angular/core';
import { AssetsService } from '@assetaccountant/assets/services/assets.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ExportModalComponent } from '../components/export-modal/export-modal.component';
import { Register } from '../models/register';
import { downloadBlob } from '../utils/file-utils';
import { setupModal } from '../utils/typed-modal';
import { RegisterService } from './register.service';

@Injectable({ providedIn: 'root' })
export class ExportService {
  constructor(
    private assetsService: AssetsService,
    private ngbModal: NgbModal,
    private registerService: RegisterService,
  ) {}

  exportAsset(asset: { assetId: number; name: string }) {
    return this.export(this.assetsService.export(asset.assetId), asset.name);
  }

  exportRegister(register: Register) {
    return this.export(
      this.registerService.export(register.id),
      `${register.entityName} - ${register.name}`,
    );
  }

  private export(request: Observable<object>, name: string) {
    const modalRef = setupModal(this.ngbModal.open(ExportModalComponent));

    return request.pipe(
      tap(response => {
        const blob = new Blob([JSON.stringify(response, null, '  ')], {
          type: 'text/json;charset=utf-8',
        });

        modalRef.close();

        downloadBlob(blob, `${name}.json`);
      }),
    );
  }
}
